
import axios from 'axios';
import { getServerError } from '../error/error-service';
import { IApiRelationLink } from './relation-link-service.types';

const DocApiBaseUrl = `/doc-api`;

export const getRelationLinkList = (documentKey: string) => {
    return axios.get<IApiRelationLink[]>(`${DocApiBaseUrl}/document/${documentKey}/relation-link`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}


export const createRelationLink = (documentKey: string, relationType: string, relatedDocumentKey: string) => {
    return axios.post(`${DocApiBaseUrl}/document/${documentKey}/relation-link`, { relationType, relatedDocumentKey })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}


export const deleteRelationLink = (documentKey: string, relationLinkId: number) => {
    return axios.delete(`${DocApiBaseUrl}/document/${documentKey}/relation-link/${relationLinkId}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}